import './styles.css';
import { PRESETS } from './constants';
import { state } from './state';
import { applyCalibration, syncCalibUI } from './calibration';
import { setViewMode, applyCamera, resize, animate } from './camera';
import { buildBook } from './book';
import { initControls } from './controls';

// ─── Init ──────────────────────────────────────────────────────────
initControls(); // wires DOM (incl. preset dropdown options) before init touches them

resize();
// default calibration: Screen (calibrated)
(function () {
  const p = PRESETS[0];
  state.tempK = p.tempK;
  state.tint = p.tint;
  state.exposure = p.exposure;
  (document.getElementById('presetSel') as HTMLSelectElement).value = '0';
  syncCalibUI();
  applyCalibration();
})();
setViewMode('turntable');
buildBook();
applyCamera();
animate();
(document.getElementById('demoBtn') as HTMLButtonElement).click();
